import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { MotorsSectionBase } from '../../motors-section-base';
import { ActivatedRoute } from '@angular/router';
import { getSummarySectionLinkText } from '../../../helpers/summary-page.helper';

@Component({
    selector: 'motors-summary-page-vehicle-details-section',
    templateUrl: './summary-page-vehicle-details-section.component.html',
    styleUrls: ['./summary-page-vehicle-details-section.component.scss'],
    standalone: false
})
export class SummaryPageVehicleDetailsSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {

    stepIds = StepIds;

    make: string;
    model: string;
    year: number;
    fuelType: string;
    hullType: string;
    length: string;
    engineMake: string;
    engineYear: number;
    engineSize: string;
    engineType: string;
    engineHours: string;
    boatLocation: string;
    isBrandNewBoat: string;
    summarySectionLinkText: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: MotorsDraftFacade,
        private route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            const dontKnow = 'Don\'t know';

            this.make =
                this.draftData.vehicleDetails.make ?
                    this.metadata.make.find((f) => f.value === this.draftData.vehicleDetails.make).display :
                    dontKnow;

            this.model = this.draftData.vehicleDetails.model;
            this.year = this.draftData.vehicleDetails.year;

            this.fuelType =
                this.draftData.vehicleDetails.fuelType ?
                    this.metadata.fuelType.find((f) => f.value === this.draftData.vehicleDetails.fuelType).display :
                    dontKnow;

            this.hullType =
                this.draftData.vehicleDetails.hullType ?
                    this.metadata.hullMaterial.find((f) => f.value === this.draftData.vehicleDetails.hullType).display :
                    dontKnow;

            const lengthUnit = this.metadata.lengthUnits.find((f) =>
                f.value === this.draftData.vehicleDetails.lengthUnit).display.toLowerCase();
            this.length = this.draftData.vehicleDetails.length ?
                `${this.draftData.vehicleDetails.length.toLocaleString()} ${lengthUnit}` : null;

            this.engineMake = this.draftData.vehicleDetails.engineMake;
            this.engineYear = this.draftData.vehicleDetails.engineYear;

            if (this.draftData.vehicleDetails.engineSize) {
                const sizeUnit = this.metadata.engineSizeUnits.find((f) =>
                    f.value === this.draftData.vehicleDetails.engineSizeUnit).display;
                this.engineSize = `${this.draftData.vehicleDetails.engineSize.toLocaleString()} ${sizeUnit}`;
            }

            this.engineType = this.metadata.engineType.find((f) => f.value === this.draftData.vehicleDetails.engineType).display;
            this.engineHours = this.draftData.vehicleDetails.engineHours ?
                `${this.draftData.vehicleDetails.engineHours.toLocaleString()} hrs` : null;

            this.boatLocation = this.metadata.boatLocation.find((f) => f.value === this.draftData.vehicleDetails.boatLocation).display;
            this.isBrandNewBoat = this.draftData.vehicleDetails.isBrandNewBoat ? 'Yes' : 'No';

            this.summarySectionLinkText = getSummarySectionLinkText(this.route);

            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
